// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
    apiKey: "AIzaSyALKfsWSwT3O_UP-JLHvTbLKIc-OsGOWe4",
    // authDomain custom (bukan ai8saat.firebaseapp.com) — supaya popup Google & email
    // Google tunjuk domain brand sendiri. Prasyarat: app.sesaat.ai didaftar di
    // GCP OAuth client (origins + redirect /__/auth/handler) + Firebase Authorized domains.
    authDomain: "app.sesaat.ai",
    projectId: "ai8saat",
    storageBucket: "ai8saat.firebasestorage.app",
    messagingSenderId: "590162652349",
    appId: "1:590162652349:web:595e4acaad5a289b3f1bd4",
    measurementId: "G-6ENVEW0969"
};

const app = initializeApp(firebaseConfig);

// App Check init — gated on VITE_RECAPTCHA_ENTERPRISE_SITE_KEY env var.
// Without a real key, attempting to init produces 403 floods from
// content-firebaseappcheck.googleapis.com on every Firebase call.
const RECAPTCHA_ENTERPRISE_SITE_KEY = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY;
if (typeof window !== 'undefined' && RECAPTCHA_ENTERPRISE_SITE_KEY) {
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        // @ts-ignore
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    try {
        initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
            isTokenAutoRefreshEnabled: true
        });
        console.log('[AppCheck] ✅ Initialized');
    } catch (e) {
        console.warn('[AppCheck] ⚠️ Init failed (non-fatal):', (e as Error).message);
    }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-southeast1'); // KL region for faster response

// Uncomment this line when testing locally with emulator:
// connectFunctionsEmulator(functions, 'localhost', 5001);

// ★ Hosted Beta DEV — arahkan Firestore+Auth ke EMULATOR supaya dev TIDAK menulis production.
//   HANYA bila VITE_USE_EMULATOR='1' + localhost. Production (env tiada) = TIDAK disentuh langsung.
if (import.meta.env.VITE_USE_EMULATOR === '1' && typeof window !== 'undefined'
    && (location.hostname === 'localhost' || location.hostname === '127.0.0.1')) {
    try { connectFirestoreEmulator(db, '127.0.0.1', 8099); } catch { /* abai */ }
    try { connectAuthEmulator(auth, 'http://127.0.0.1:9199', { disableWarnings: true }); } catch { /* abai */ }
    try { connectFunctionsEmulator(functions, '127.0.0.1', 5002); } catch { /* abai */ }
    // eslint-disable-next-line no-console
    console.log('[DEV] Firestore+Auth → EMULATOR (VITE_USE_EMULATOR=1) — tiada tulisan production');
}
